import React from "react";
import { Box, Typography } from "@mui/material";
import { useScreenshotTranslation } from "../../../lib/screenshotI18n";
import {
    featurePillSx,
    featurePillsRowSx,
    galleryHeaderAmbientSx,
    galleryHeaderSx,
    galleryHeadlineDarkSx,
    galleryHeadlineSx,
    promoHeadlineLightSx,
    promoHeadlineStackSx,
    promoHeadlineSubtitleLightSx,
    promoHeadlineSubtitleSx,
    promoHeadlineSx,
    promoHeadlineGiantSx,
    promoHeadlineStackGiantSx,
    promoHeaderLightSx,
    promoHeaderSx,
} from "../styles/screenshotStyles";

function FeaturePill({ icon, label }) {
    return (
        <Box component="span" sx={featurePillSx}>
            <Box component="span" aria-hidden sx={{ fontSize: "0.82rem", lineHeight: 1 }}>
                {icon}
            </Box>
            {label}
        </Box>
    );
}

/** Promo headline + subtitle + optional feature pills (top of screenshot page). */
export default function ScreenshotPromoHeader({
    promoHeadline,
    promoSubtitle,
    variant = "promo",
    showPills = true,
    light = false,
}) {
    const { t } = useScreenshotTranslation();
    const isGallery = variant === "gallery";
    const isThemes = variant === "themes";
    const isGiant = variant === "giant";

    let headerSx = promoHeaderSx;
    let headlineSx = promoHeadlineSx;
    let subtitleSx = promoHeadlineSubtitleSx;
    if (isThemes) {
        headerSx = galleryHeaderAmbientSx;
        headlineSx = galleryHeadlineDarkSx;
        subtitleSx = promoHeadlineSubtitleSx;
    } else if (isGallery) {
        headerSx = galleryHeaderSx;
        headlineSx = galleryHeadlineSx;
    } else if (isGiant) {
        // `light` means light type on a dark shell; without it (e.g. theme:"light") use navy type.
        if (light) {
            headerSx = promoHeaderLightSx;
            headlineSx = promoHeadlineGiantSx;
            subtitleSx = promoHeadlineSubtitleLightSx;
        } else {
            headerSx = promoHeaderSx;
            headlineSx = { ...promoHeadlineGiantSx, color: "#0f172a", textShadow: "none" };
            subtitleSx = promoHeadlineSubtitleSx;
        }
    } else if (light) {
        headerSx = promoHeaderLightSx;
        headlineSx = promoHeadlineLightSx;
        subtitleSx = promoHeadlineSubtitleLightSx;
    }

    return (
        <Box sx={headerSx}>
            <Box sx={isGiant ? promoHeadlineStackGiantSx : promoHeadlineStackSx}>
                <Typography component="h1" sx={headlineSx}>
                    {promoHeadline}
                </Typography>
                {promoSubtitle && !isGallery ? (
                    <Typography component="p" sx={subtitleSx}>
                        {promoSubtitle}
                    </Typography>
                ) : null}
            </Box>
            {!isGallery && !isThemes && showPills ? (
                <Box sx={featurePillsRowSx}>
                    <FeaturePill icon="🧩" label={t("mobileScreenshot.sliding.pill-quick-moves")} />
                    <FeaturePill icon="✨" label={t("mobileScreenshot.sliding.pill-smooth-sliding")} />
                </Box>
            ) : null}
        </Box>
    );
}
